import { useState, useEffect } from 'react';
import { UserOutlined} from '@ant-design/icons';
import { Tabs, Space, Badge, Input } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Button, Form, Spin } from 'antd';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box,  Typography } from '@mui/material';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import DataHistoCpt from '../../../../Types/DataHistoCpt';
import ExtourneOp from '../../../../Types/ExtouneOp';
import VerifDay from '../../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';


//import '../../../Assets/Styles/StyleForm.css';
const Swal = require('sweetalert2');

const Extourne = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [ajoutActve, setAjoutActif] = useState(false)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [consulActive, setConsulActive] = useState(false)
    const [ExtourActive, setExtourActive] = useState(true)
    const [sbmit, setSbmit] = useState("");
    const [DataOperation, setDataOperation] = useState<DataHistoCpt[]>([]);
    const [Index, SetIndex] = useState<any>(-1);
    const [StartRef, SetStartRef] = useState(false);
    const [DissablLibeOp, SetDissablLibeOp] = useState(true);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const Navigate=useNavigate();

    useEffect(() => {
        forceUpdate({});
        if (StartForm == true) {
            //  GetAllOperation();
            VerifDay(user.coduti,user.codage,authHeader,Navigate);
            SetStartForm(false);
        }
    }, []);

    function cunsultButton() {
        //setAnnulActive(false)
        setSbmit("add");
        setConsulActive(false);
        SetStartRef(true);
        setExtourActive(false);
        setEnregActve(true);
        setModifActve(true);
    

    }

    function OnfinishButton() {
        setExtourActive(true);
        // SetActivetabs(true)
    }

    const columns: ColumnsType<DataHistoCpt> = [
        {
            title: 'DateOpe',
            dataIndex: 'DATOPE',
            ellipsis: true,
            width: 100,
            render: (text: any, reccord: any) => (
                <span>
                    {ReformatDate(text)}
                </span>
            )
        }, {
            title: 'Heure',
            dataIndex: 'TIME',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'N° Compte',
            dataIndex: 'NUMCPT',
            ellipsis: true,
            width: 200,
            // filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCPT)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.SENSEC)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.REPECE)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.MONTANT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.LIBELL)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Utilis)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Motif)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Sens',
            dataIndex: 'SENSEC',
            ellipsis: true,
            width: 100,
            align:'center',
            render: (text: any, reccord: any) => (
                <Box sx={{ alignItems: 'center' }} >
                    <Badge status='success' color={reccord.SENSEC == "C" ? 'green' : reccord.SENSEC == "D" ? 'red' : 'orange'} size='default' count={reccord.SENSEC == "D" ? 'Debit' : reccord.SENSEC == "C" ? 'Credit' : 'No sence'}> </Badge>
                </Box>
            )
        },
        {
            title: 'Reférence',
            dataIndex: 'REPECE',
            ellipsis: true,
            width: 150
        },
        {
            title: 'Numrap',
            dataIndex: 'NUMRAP',
            ellipsis: true,
            width: 100
        },
        {
            title: 'Montant',
            dataIndex: 'MONTANT',
            ellipsis: true,
            width: 150
        },
        {
            title: 'Beneficiare',
            dataIndex: 'NBENEF',
            ellipsis: true,
            width: 150
        },
        {
            title: 'Utisai',
            dataIndex: 'UTISAI',
            ellipsis: true,
            width: 100
        },
        {
            title: 'NLIGNE',
            dataIndex: 'NLIGNE',
            ellipsis: true,
            width: 100
        }
        ,
        {
            title: 'CODOPE',
            dataIndex: 'CODOPE',
            ellipsis: true,
            width: 100
        },
        {
            title: 'Libelle',
            dataIndex: 'LIBELL',
            ellipsis: true,
            width: 200
        }
    ];

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Extorune  des Opérations
                </span>
            ),
            children: <Tab1 etatG={StartRef} form={form} dissablelibop={DissablLibeOp} consult={()=>{consult()}} />,
        }
    ]

    const onFinish = async (values: any) => {

        // Index!=-1?DataOperation[Index].LIBELL=values.lib_CodeOpe:SweetAlert.fire({ title: "Error", text: "veuillez", icon: "info" });

        setLoading(true);
        if (sbmit == "add") {
            const IndexTable = DataOperation.findIndex(ligne => ligne.key == Index);
            DataOperation[IndexTable].LIBELL = values.lib_CodeOpe;

            let dataT: DataHistoCpt[] = [];
            DataOperation.map((d) => {
                dataT.push(d);
            })

            setDataOperation(dataT);
            
        }
        else if (sbmit == "Ex") {

            let listExtourneOp: ExtourneOp[] = [];

            DataOperation.map((d) => {
                listExtourneOp.push({
                    Libelle: d.LIBELL,
                    Ligne: d.NLIGNE ? d.NLIGNE : 0
                })
            })

            let data = form.getFieldValue("Reference")
            var config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.Extourne,
                headers: {
                    'Accept': '*/*',
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherCodeA': Crypter.encrypt(user.codage),
                    'CypherCodeU': Crypter.encrypt(user.coduti),
                    'CypherRepec': Crypter.encrypt(data)
                },
                data: Crypter.encrypt(JSON.stringify(listExtourneOp))
            };

            await
                axios(config)
                    .then((response) => {
                        //alert('ok')
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                            if (res.StatutCode == 200) {
                                let datas = res.Result.Table[0];
                               
                                SweetAlert.fire({ title: datas.result, text: "Reférence :" + datas.reference, icon: "success" });
                                form.resetFields();
                                setDataOperation([]);
                                SetStartRef(false);
                                OnfinishButton(); 
                            }
                            else SweetAlert.fire({ title: "Warning", text: res.Message, icon: "error" })
                            setLoading(false);
                        }
                        //  setLoad(false);
                    }).catch((error) => {
                        SweetAlert.fire({ title: "Warning", text: error.message, icon: "error" })
                    })
            setLoading(false);
        }

        setLoading(false);
    };

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const consult = async () => {

        setLoading(true);
        setDataOperation([]);
        // form.resetFields()
        form.setFieldsValue({ "TotalDebitOP": '', 'TotalCrebitOP': '', 'NbrCrebitOP': '', 'NbrdebitOP': '', 'SoldeOP': '', 'NbrTotalOP': '', 'Devise': '', 'lib_Devise': '', 'AUTORI': '', 'CDDEVS': '', 'lib_CDDEVS': '' })

        var data = Crypter.encrypt(form.getFieldValue("Reference"))

        if (data.length != 0) {
            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetOperation,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherFilter': Crypter.encrypt('8'),
                    'CypherCodeA': Crypter.encrypt(user.codage),
                    'CypherCodeU': Crypter.encrypt(user.coduti),
                    'CypherRepec': Crypter.encrypt(form.getFieldValue("Reference"))
                }
            };

            await
                axios(config)
                    .then((response) => {

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                            if (res.StatutCode == 200) {
                                let datas = res.Result;

                                const Datat: DataHistoCpt[] = [];
                                if (datas.length === 0) {
                                    SweetAlert.fire({ title: "Warning", text: "", icon: "warning" })
                                }
                                else {

                                    let TotalDebit: number = 0;
                                    let TotalCrebit: number = 0;
                                    let NbrCrebit: number = 0;
                                    let Nbrdebit: number = 0;

                                    res.Result.map((data: any, indice: number) => {

                                        if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                        else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                        Datat.push({
                                            key: indice,
                                            NUMCPT: data.NODUCP,
                                            DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                            TIME: data.TIME.substring(11,),
                                            DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                            SENSEC: data.SENSEC,
                                            REPECE: data.REPECE,
                                            NUMRAP: data.NUMRAP,
                                            LIBELL: data.LIBELL,
                                            MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                            MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                            MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                            SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                            NBENEF: data.NBENEF,
                                            UTISAI: data.UTISAI,
                                            CODOPE: data.CDLBEC,
                                            NLIGNE: data.NLIGNE,
                                            NOMCPT: data.NOMCPT,
                                            RelObject: data
                                        });

                                        setDataOperation(Datat);
                                        form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                                        form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                                        form.setFieldValue("NbrCrebit", NbrCrebit);
                                        form.setFieldValue("Nbrdebit", Nbrdebit);
                                        form.setFieldValue("Solde", formatNumber(TotalCrebit - TotalDebit));
                                        form.setFieldValue("NbrTotal", NbrCrebit + Nbrdebit);

                                        cunsultButton();
                                    })
                                }
                            } else SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            setLoading(false);
                        }
                        //  setLoad(false);
                    }).catch((error) => {
                        SweetAlert.fire({ title: "Warning", text: error.message, icon: "warning" })
                    })

            setLoading(false);
        }
    }

    function modifButton() {
       
        setModifActve(true)
        setAjoutActif(true)
        setEnregActve(false)
        setConsulActive(true)
        SetDissablLibeOp(false);
    }

    function annulButton() {
       
        form.resetFields();
       // setConsulActive(false);
        SetStartRef(false);
         setDataOperation([]);
       // setExtourActive(false);
       // setEnregActve(true);
       // setModifActve(true);
    }

    function modif() {
        modifButton()
    }

    const onSelectChange = (newSelectedRowKeys: any) => {
        setSelectedRowKeys(newSelectedRowKeys);
        let data = DataOperation[newSelectedRowKeys];
        form.setFieldsValue({
            'CodeOpe': data.CODOPE, 'lib_CodeOpe': data.LIBELL, 'NUMCPT': data.NUMCPT, 'lib_NUMCPT': data.NOMCPT,
            'Montant': data.MONTANT, 'Sence': data.SENSEC, 'RefManuel': data.NUMRAP
        });

        SetIndex(newSelectedRowKeys);
        setModifActve(false);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Extourne Opération </b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button> */}
                                
                                {/* <Button size='large' className='bt_add' onClick={e => { setSbmit("add") }} disabled={enregActve} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button> */}
                                <Button size='large' className='bt_add' onClick={e => { setSbmit("Ex") }} disabled={ExtourActive} type="ghost" htmlType="submit" block>
                                    Extourner
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={annulButton} type="ghost" htmlType="button" block  >
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Box marginBottom={'0.1em'}>
                                <Tabs size='large' type="card" onChange={(e) => {
                                    // if (e == '2') {   // GetAllOperationV(); }
                                }} defaultActiveKey="1" items={items} />
                            </Box>
                            <Box fontStyle="inherit" className='tabElementAuto' marginTop={'-12%'}>
                                <Table sticky={true} columns={columns} rowSelection={{ ...rowSelection, selectedRowKeys, getCheckboxProps: (reccord) => ({ disabled: false }), type: 'radio' }} size='small' style={{ width: '100%' }} pagination={false} scroll={{ y: 250, x: 20 }} dataSource={DataOperation} />
                                
                                 <Box className='bordure1'  width={"98%"} marginTop={"5px"} fontStyle="inherit">
                                       <Space.Compact >
                                        <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre" name='TotalCrebit'><Input disabled /></Form.Item>
                                        <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
                                    </Space.Compact>
                                    <Space.Compact >
                                        <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre" name='TotalDebit'><Input disabled /></Form.Item>
                                        <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
                                    </Space.Compact>
                                    <Space.Compact >
                                        <Form.Item label="Balance" name='Solde'><Input disabled /></Form.Item>
                                    </Space.Compact>
                                </Box>
                                 
                            </Box>
                               
                            
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div >

    );
}
export default Extourne;